import React from 'react';
import { useObservable } from 'react-use-observable';

import { Button } from 'antd';

import isAfter from 'date-fns/isAfter';
import startOfDay from 'date-fns/startOfDay';
import { Form as FormikForm, Field, useFormikContext } from 'formik';
import { FilterActions } from 'v2/components/Pages/Reports/FilterActions';
import { FilterPanel } from 'v2/components/Pages/Reports/FilterPanel';
import { DateRangePickerFormField } from 'v2/components/Shared/FormFields/DateRangePicker';
import { SelectFormField } from 'v2/components/Shared/FormFields/SelectFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import { ECustomerSearchTypes } from 'v2/interfaces/reports/partnerCommissions';
import type { IPartnerCommissionFilter } from 'v2/interfaces/reports/partnerCommissions';
import { initialFilter, partnerCommissionsService } from 'v2/services/reports/partnerCommissions';

import { Icon } from '@eduzz/ui-antd-theme';

const customerTypes = [
  { label: 'E-mail', value: ECustomerSearchTypes.EMAIL },
  { label: 'Nome', value: ECustomerSearchTypes.NAME }
];

export const Form = () => {
  const { values, setFieldValue, isValid, isSubmitting, resetForm, dirty } =
    useFormikContext<IPartnerCommissionFilter>();

  const [isLoading] = useObservable(() => partnerCommissionsService.isLoading(), []);

  const isOutsideRange = (day: Date) => isAfter(startOfDay(day), startOfDay(new Date()));

  const onChangeCustomerType = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFieldValue('commissioned', '');
    setFieldValue('commissioned_type', e.target.value);
  };

  const handleClean = () => {
    resetForm({ values: initialFilter });
  };

  const customerLabel = values.commissioned_type === ECustomerSearchTypes.NAME ? 'Nome' : 'E-mail';
  const customerPlaceholder =
    values.commissioned_type === ECustomerSearchTypes.NAME ? 'Insira o nome' : 'Insira o e-mail';

  const isFilterDisabled = !isValid || isSubmitting || isLoading;
  const isCleanDisabled = !dirty || isSubmitting || isLoading;

  return (
    <FormikForm>
      <FilterPanel id='commissions-paid-to-partners'>
        <div className='grid grid-cols-1 items-end gap-4 sm:grid-cols-2 lg:grid-cols-12'>
          <div className='lg:col-span-3'>
            <Field
              label='Período'
              id='date'
              name='date'
              component={DateRangePickerFormField}
              isPresetLonger
              isOutsideRange={isOutsideRange}
            />
          </div>
          <div className='lg:col-span-5'>
            <div className='grid grid-cols-3 gap-2'>
              <div>
                <Field
                  id='commissioned_type'
                  name='commissioned_type'
                  label='Parceiro'
                  options={customerTypes}
                  onChange={onChangeCustomerType}
                  component={SelectFormField}
                  fullWidth
                />
              </div>
              <div className='col-span-2'>
                <Field
                  id='commissioned'
                  name='commissioned'
                  label={customerLabel}
                  placeholder={customerPlaceholder}
                  component={TextFormField}
                  fullWidth
                />
              </div>
            </div>
          </div>
          <div className='lg:col-span-4'>
            <FilterActions>
              <Button id='clean-filter-button' onClick={handleClean} type='text' disabled={isCleanDisabled}>
                Limpar
              </Button>
              <Button
                id='filter-button'
                type='primary'
                disabled={isFilterDisabled}
                htmlType='submit'
                loading={isSubmitting || isLoading}
                icon={<Icon.Funnel />}
              >
                Filtrar
              </Button>
            </FilterActions>
          </div>
        </div>
      </FilterPanel>
    </FormikForm>
  );
};
